/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum OperationType {
  Add = "Add",
  Remove = "Remove",
  Replace = "Replace",
  Move = "Move",
  Copy = "Copy",
  Test = "Test",
  Invalid = "Invalid",
}

export enum ExecutionMode {
  Production = "Production",
  Testing = "Testing",
}

export interface AgentTypeDto {
  /** @format int32 */
  agencyRef?: number;
  /** @format uuid */
  id?: string;
  isAdmin?: boolean;
}

export interface AssignAgentDto {
  /** @format int32 */
  refNumber?: number;
}

export interface CreateAgencyInput {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  streetAddress?: string | null;
  postcode?: string | null;
  executionMode?: ExecutionMode;
}

export interface InviteAgentInput {
  email?: string | null;
  /** @format int32 */
  refNumber?: number;
}

export interface Operation {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface PerformerAgency {
  nudgeAllowed?: boolean;
  suggestAllowed?: boolean;
  /** @format int32 */
  id?: number;
  name?: string | null;
  isInvalid?: boolean;
}

export interface PerformerDto {
  artistReference?: string | null;
  surname?: string | null;
  forenames?: string | null;
  userType?: string | null;
  /** @format int32 */
  publicationCode?: number;
  /** @format date-time */
  expiryDate?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  mainPhoto?: PhotoDto;
  _links?: any | null;
  /** @format int32 */
  playingAgeFrom?: number | null;
  /** @format int32 */
  playingAgeTo?: number | null;
  appearances?: number[] | null;
}

export interface PerformerPrivilegesDto {
  surname?: string | null;
  forenames?: string | null;
  id?: string | null;
  /** @format int32 */
  performerType?: number;
  agencies?: PerformerAgency[] | null;
}

export interface PerformersSetDto {
  /** @format int32 */
  total?: number;
  performers?: PerformerDto[] | null;
  _links?: any | null;
}

export interface PhotoDto {
  fileName?: string | null;
}

export interface SetIsLookingForRepresentationDto {
  isLookingForRep?: boolean;
}

export interface UpdateAgencySettingsInput {
  /** @format int32 */
  agencyRefNumber?: number;
  treatJobsAsRead?: boolean;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Modern Agent API V1s
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  agencies = {
    /**
     * No description
     *
     * @tags Agency
     * @name AgenciesList
     * @request GET:/agencies
     * @secure
     */
    agenciesList: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        PerformerType?: number;
        Name?: string;
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        AgentsOrSchools?: string;
        AllowAnonymousAccess?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name AgenciesCreate
     * @request POST:/agencies
     * @secure
     */
    agenciesCreate: <TResponse = unknown, TError = any>(
      data: CreateAgencyInput,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name AgentsList
     * @request GET:/agencies/agents
     * @secure
     */
    agentsList: <TResponse = unknown, TError = any>(
      query?: {
        RefNumber?: number[];
        ShowSsoUsers?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/agents`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name GetAgencies
     * @request GET:/agencies/fm
     * @secure
     */
    getAgencies: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/fm`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name DetailsList
     * @request GET:/agencies/{refNumber}/details
     * @secure
     */
    detailsList: <TResponse = unknown, TError = any>(
      refNumber: number,
      query?: {
        state?: string;
        showSsoUsers?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${refNumber}/details`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name MainContactList
     * @request GET:/agencies/{refNumber}/mainContact
     * @secure
     */
    mainContactList: <TResponse = unknown, TError = any>(
      refNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${refNumber}/mainContact`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name InviteCreate
     * @request POST:/agencies/invite
     * @secure
     */
    inviteCreate: <TResponse = unknown, TError = any>(
      data: InviteAgentInput,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/invite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name CancelInvitesDelete
     * @request DELETE:/agencies/{refNumber}/cancelInvites
     * @secure
     */
    cancelInvitesDelete: <TResponse = unknown, TError = any>(
      refNumber: number,
      query?: {
        emails?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${refNumber}/cancelInvites`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name AgentsDelete
     * @request DELETE:/agencies/{agencyRefNumber}/agents
     * @secure
     */
    agentsDelete: <TResponse = unknown, TError = any>(
      agencyRefNumber: number,
      query?: {
        agentPortalIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${agencyRefNumber}/agents`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name SettingsList
     * @request GET:/agencies/{agencyRefNumber}/settings
     * @secure
     */
    settingsList: <TResponse = unknown, TError = any>(
      agencyRefNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${agencyRefNumber}/settings`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name SettingsCreate
     * @request POST:/agencies/{agencyRefNumber}/settings
     * @secure
     */
    settingsCreate: <TResponse = unknown, TError = any>(
      agencyRefNumber: number,
      data: UpdateAgencySettingsInput,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${agencyRefNumber}/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agency
     * @name FilmmakersSsoLinkList
     * @request GET:/agencies/{agencyRefNumber}/filmmakers-sso-link
     * @secure
     */
    filmmakersSsoLinkList: <TResponse = unknown, TError = any>(
      agencyRefNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agencies/${agencyRefNumber}/filmmakers-sso-link`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  agencyMapping = {
    /**
     * No description
     *
     * @tags AgencyMapping
     * @name TagminList
     * @request GET:/agency-mapping/tagmin
     * @secure
     */
    tagminList: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agency-mapping/tagmin`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgencyMapping
     * @name TagminDetail
     * @request GET:/agency-mapping/tagmin/{externalId}
     * @secure
     */
    tagminDetail: <TResponse = unknown, TError = any>(
      externalId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agency-mapping/tagmin/${externalId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgencyMapping
     * @name OrganisationDetail
     * @request GET:/agency-mapping/organisation/{orgId}
     * @secure
     */
    organisationDetail: <TResponse = unknown, TError = any>(
      orgId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agency-mapping/organisation/${orgId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgencyMapping
     * @name AgencyDetail
     * @request GET:/agency-mapping/agency/{refNumber}
     * @secure
     */
    agencyDetail: <TResponse = unknown, TError = any>(
      refNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agency-mapping/agency/${refNumber}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgencyMapping
     * @name ExternalDetail
     * @request GET:/agency-mapping/external/{externalId}
     * @secure
     */
    externalDetail: <TResponse = unknown, TError = any>(
      externalId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agency-mapping/external/${externalId}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  agents = {
    /**
     * No description
     *
     * @tags Agents
     * @name ClientsList
     * @request GET:/agents/{siteUserId}/clients
     * @secure
     */
    clientsList: <TResponse = PerformersSetDto, TError = any>(
      siteUserId: number,
      query?: {
        contractStatus?: string[];
        gender?: number[];
        appearances?: number[];
        artistName?: string;
        sortOrder?: string;
        orderBy?: string;
        skip?: string;
        take?: string;
        /** @format int32 */
        playingAgeFrom?: number;
        /** @format int32 */
        playingAgeTo?: number;
        locationId?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agents/${siteUserId}/clients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agents
     * @name TypeUpdate
     * @request PUT:/agents/type
     * @secure
     */
    typeUpdate: <TResponse = unknown, TError = any>(
      data: AgentTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agents/type`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Privileges
     * @name ClientsPrivilegesList
     * @request GET:/agents/{siteUserId}/clients/privileges
     * @secure
     */
    clientsPrivilegesList: <TResponse = PerformerPrivilegesDto[], TError = any>(
      siteUserId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agents/${siteUserId}/clients/privileges`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Privileges
     * @name ClientsPrivilegesPartialUpdate
     * @request PATCH:/agents/{siteUserId}/clients/privileges
     * @secure
     */
    clientsPrivilegesPartialUpdate: <
      TResponse = PerformerPrivilegesDto[],
      TError = any,
    >(
      siteUserId: number,
      data: PerformerPrivilegesDto[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/agents/${siteUserId}/clients/privileges`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  getagencies = {
    /**
     * No description
     *
     * @tags AnonAgency
     * @name GetagenciesList
     * @request GET:/getagencies
     * @secure
     */
    getagenciesList: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        PerformerType?: number;
        Name?: string;
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        AgentsOrSchools?: string;
        AllowAnonymousAccess?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/getagencies`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  external = {
    /**
     * No description
     *
     * @tags External
     * @name FilmmakersDetail
     * @request GET:/external/filmmakers/{externalId}
     * @secure
     */
    filmmakersDetail: <TResponse = unknown, TError = any>(
      externalId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/external/filmmakers/${externalId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags External
     * @name FilmmakersAgenciesMappingsCsvList
     * @request GET:/external/filmmakers/agencies-mappings/csv
     * @secure
     */
    filmmakersAgenciesMappingsCsvList: <TResponse = unknown, TError = any>(
      query?: {
        externalIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/external/filmmakers/agencies-mappings/csv`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  performers = {
    /**
     * No description
     *
     * @tags Performer
     * @name AgentsList
     * @request GET:/performers/{artistRef}/agents
     * @secure
     */
    agentsList: <TResponse = unknown, TError = any>(
      artistRef: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/performers/${artistRef}/agents`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Performer
     * @name AgentsCreate
     * @request POST:/performers/{artistRef}/agents
     * @secure
     */
    agentsCreate: <TResponse = unknown, TError = any>(
      artistRef: string,
      data: AssignAgentDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/performers/${artistRef}/agents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Performer
     * @name AgentsPartialUpdate
     * @request PATCH:/performers/{artistRef}/agents
     * @secure
     */
    agentsPartialUpdate: <TResponse = unknown, TError = any>(
      artistRef: string,
      data: Operation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/performers/${artistRef}/agents`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Performer
     * @name SetislookingforrepCreate
     * @request POST:/performers/{artistRef}/setislookingforrep
     * @secure
     */
    setislookingforrepCreate: <TResponse = unknown, TError = any>(
      artistRef: string,
      data: SetIsLookingForRepresentationDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/performers/${artistRef}/setislookingforrep`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Performer
     * @name AgentsDelete
     * @request DELETE:/performers/{artistRef}/agents/{refNumber}
     * @secure
     */
    agentsDelete: <TResponse = unknown, TError = any>(
      artistRef: string,
      refNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/performers/${artistRef}/agents/${refNumber}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  whoAmI = {
    /**
     * No description
     *
     * @tags WhoAmI
     * @name WhoAmIList
     * @request GET:/WhoAmI
     * @secure
     */
    whoAmIList: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/WhoAmI`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
